import React from 'react'

import { AdjustmentStatus as AdjustmentStatusEntries } from '@ztechapps/adjustment.common'
import { StatusColorBadge, StatusColorDot, findStatus } from '@ztechapps/webui.util'

export type AdjustmentStatusProps = { status: string }

export const AdjustmentStatusBadge = ({ status }: AdjustmentStatusProps) => (
  <StatusColorBadge status={status} color={findStatus(AdjustmentStatusEntries, status)} />
)

export const AdjustmentStatus = ({ status }: AdjustmentStatusProps) => (
  <StatusColorDot value={status} color={findStatus(AdjustmentStatusEntries, status)} />
)
